import { createConsumer } from "@rails/actioncable";
import { Cubby } from "../stores/Cubby";
import { Rizvoice } from "../stores/Rizvoice";

declare global {
  interface Window {
    AccountsSubscription: any;
  }
}

export const startAccountsActionCable = (
  cubby: Cubby | null = null,
  rizVoice: Rizvoice | null = null
) => {
  const consumer = createConsumer();
  //console.log(consumer);
  //console.log("--in start action cable---");
  // console.log("workspace.channelIndex", workspace.channelIndex);
  window.AccountsSubscription = consumer.subscriptions.create(
    {
      channel: "AccountsChannel",
    },

    {
      connected() {
        console.log("cable connect");
        if (rizVoice) {
          console.log("setting rizvoice has loaded");
          rizVoice.setToHasLoaded();
        }
      },

      disconnected() {
        // Called when the subscription has been terminated by the server
      },
      received(receivedData) {
        console.log(
          // "data received from rails",
          receivedData.message,
          receivedData.data
        );

        // Cubby

        if (receivedData.message == "update-run-status") {
          cubby.updateRunStatus(receivedData.data);
        }
        if (receivedData.message == "update-cubby-info") {
          cubby.updateInfo(receivedData.data);
        }
        if (receivedData.message == "update-onchain-addresses") {
          cubby.updateOnchainAddresses(receivedData.data);
        }
        if (receivedData.message == "update-onchain-balances") {
          cubby.updateOnchainBalances(receivedData.data);
        }
        if (receivedData.message == "update-cubby-errors") {
          cubby.updateCubbyErrors(receivedData.data);
        }
        if (receivedData.message == "update-add-peer-successes") {
          cubby.updateAddPeerSuccesses(receivedData.data);
        }
        if (receivedData.message == "update-peers") {
          cubby.updatePeerLists(receivedData.data);
        }
        if (receivedData.message == "update-open-channel-successes") {
          cubby.updateOpenChannelSuccesses(receivedData.data);
        }
        if (receivedData.message == "update-close-channel-successes") {
          cubby.updateCloseChannelSuccesses(receivedData.data);
        }
        if (receivedData.message == "update-channels") {
          cubby.updateChannels(receivedData.data);
        }
        if (receivedData.message == "update-fee-estimate") {
          console.log("fee estimate results", receivedData.data);
          cubby.handleOnchainFeeEstimateResponse(
            receivedData.data.amountInSatoshis,
            receivedData.data.feesInSatoshis
          );
        }
        if (receivedData.message == "update-onchain-payment-successes") {
          cubby.updateOnchainPaymentSuccesses(receivedData.data);
        }
        if (receivedData.message == "update-decoded-pay-request") {
          cubby.updateDecodedPayRequest(receivedData.data);
        }
        if (receivedData.message == "update-invoice-update-events") {
          cubby.updateInvoiceUpdateEvents(receivedData.data);
        }
        if (receivedData.message == "update-pay-offchain-events") {
          cubby.updatePayOffchainEvents(receivedData.data);
        }
        if (receivedData.message == "update-bolt-eleven-user-invoices") {
          cubby.updateBoltElevenUserInvoices(receivedData.data);
        }
        if (receivedData.message == "update-tasks") {
          cubby.updateTasks(receivedData.data);
        }
        if (receivedData.message == "update-onchain-transactions") {
          cubby.updateOnchainTransactions(receivedData.data);
        }

        if (
          receivedData.message ==
          "channel-offer-invoice-error-client-node-not-connected"
        ) {
          cubby.handleChannelOfferLspError(receivedData.data);
        }
        if (
          receivedData.message ==
          "channel-offer-invoice-lnd-invoice-for-channel-purchase"
        ) {
          cubby.handleChannelOfferLspInvoiceSuccess(receivedData.data);
        }
        if (receivedData.message == "channel-offer-finalized") {
          cubby.resetChannelOffers(receivedData.data.channelOfferUuid);
        }

        if (receivedData.message == "paywall-invoice-created") {
          rizVoice.setPaywallPayRequest(receivedData.data.payRequest);
        }

        if (receivedData.message == "paywall-invoice-paid") {
          rizVoice.setMustMakeInvoicePaymentBeforeClaimingCubby(false);
        }

        if (receivedData.message == "subscription-payment-invoice-created") {
          rizVoice.setSubscriptionPaymentPayRequest(
            receivedData.data.payRequest
          );
        }

        if (receivedData.message == "subscription-payment-paid") {
          rizVoice.handleSubscriptionPaymentJustPaid();
        }
        if (receivedData.message == "update-message-signed") {
          const stagedUserInputForNodeSignature =
            receivedData.data.stagedUserInputForNodeSignature;
          const signedMessage = receivedData.data.signedMessage;
          if (
            cubby.stagedUserInputForNodeSignature ==
            stagedUserInputForNodeSignature
          ) {
            cubby.setMessageThatWasSignedByNodeText(signedMessage);
          }
        }

        // Rizvoice
      },
    }
  );
};
